var _desc, _defs, _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarfuriRefrigerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "M\u0103rfuri refrigerate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Pictogram\u0103 vectorial\u0103 cu camion frigorific \u0219i fulg de z\u0103pad\u0103.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20222B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purple",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7B248F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E1767"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 112,
    width: 326,
    height: 244,
    rx: 32,
    fill: "url(#dark)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350 188H422C439 188 454 197 463 211L500 270C506 280 510 292 510 304V332C510 345 499 356 486 356H350Z",
    fill: "url(#dark)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M398 220H423C432 220 439 224 444 232L470 274H398Z",
    fill: "#F3F4F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 366,
    r: 54,
    fill: "url(#dark)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 366,
    r: 21,
    fill: "#F3F4F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 366,
    r: 54,
    fill: "url(#dark)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 366,
    r: 21,
    fill: "#F3F4F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(218 234)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "url(#purple)",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(300)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-86M0-58L-23-37M0-58L23-37",
    transform: "rotate(300)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarfuriRefrigerate);
export default __webpack_public_path__ + "static/media/marfuri_refrigerate.51aeb2b4248d85f57a28fa4fa203d1ef.svg";
export { ForwardRef as ReactComponent };